import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { FreeMode, Scrollbar } from 'swiper';
import {
  BankLogos,
  BankLogosInv,
} from 'lb-components/src/stories/assets/icons/payment';
import _ from 'lodash';
import '../swiper.scss';
import 'swiper/css';
import 'swiper/css/scrollbar';
import Manual from '../components/Manual/Manual';
import { UseUser } from 'lb-store/src/hooks';

const bankColors = {
  BOG: '#FF671B',
  TBC: '#00ABED',
  LIB: '#E70D2F',
  LEADER_CARD: '#f1c157',
};
const bankIds = ['LEADER_CARD', 'BOG', 'TBC', 'ANY'];

const Cards = ({ platform, actionType, data, payment, onCardSubmit, lang, t, panConverter }) => {
  const [myCards, setMyCards] = useState(data);
  const [loader, setLoader] = useState(false);

  const { User,updateBalance } = UseUser();

  useEffect(() => {
    setMyCards(data);
  }, [data]);

  return (
    <>
      <Accordion style={{ marginTop: '1.5rem' }}>
        {bankIds.map((key) => {
          return (
            <Manual
              actionType={actionType}
              platform={platform}
              key={`${actionType}-${key}`}
              eventKey={key}
              type={'card'}
              panConverter={panConverter}
              balance={User.balance?.balance}
              cardOptions={key === 'ANY' ? data : _.filter(data, (card) => card.bankID === key)}
              logo={BankLogos[key]}
              t={t}
              submit={onCardSubmit}
              style={{ marginBottom: '1rem' }}
            />
          );
        })}
      </Accordion>
    </>
  );
};

export default Cards;
